import { render, staticRenderFns } from "./TaxListPage.vue?vue&type=template&id=4f8ac9a0&"
import script from "./TaxListPage.vue?vue&type=script&lang=ts&"
export * from "./TaxListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports